/**
 * AiProgress — feedback de progresso para operações de IA longas (análise/relatório).
 *
 * A geração no Bedrock leva minutos (saída grande). Sem feedback, a tela parece
 * congelada. Este componente mostra, enquanto `busy=true`: um spinner, um ESTÁGIO
 * que avança com o tempo e um CRONÔMETRO — para o usuário ver que está trabalhando.
 * (C3a — progresso rico; o streaming token-a-token real fica para o C3b.)
 */
import { useEffect, useState } from 'react';
import { C } from '@/theme/palette';

const STAGES = [
  'Analisando o contexto do projeto…',
  'Consultando a memória e o RAG…',
  'Gerando o conteúdo com a IA…',
  'Estruturando e consolidando…',
  'Quase lá, finalizando…',
];

export function AiProgress({ busy, label = 'Gerando com IA' }) {
  const [sec, setSec] = useState(0);

  useEffect(() => {
    if (!busy) {
      setSec(0);
      return undefined;
    }
    const t = setInterval(() => setSec((s) => s + 1), 1000);
    return () => clearInterval(t);
  }, [busy]);

  if (!busy) return null;

  const mm = String(Math.floor(sec / 60)).padStart(2, '0');
  const ss = String(sec % 60).padStart(2, '0');
  // Troca de estágio a cada ~12s (informativo; não é a etapa real do backend).
  const stage = STAGES[Math.min(Math.floor(sec / 12), STAGES.length - 1)];

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        marginTop: 10,
        padding: '10px 14px',
        borderRadius: 10,
        background: C.surface2 ?? '#141414',
        border: `1px solid ${C.border ?? '#262626'}`,
        fontSize: 13,
        color: C.neutral ?? '#e8e8e8',
      }}
    >
      <span
        aria-hidden="true"
        style={{
          width: 14,
          height: 14,
          borderRadius: '50%',
          border: `2px solid ${C.cyber ?? '#00E0E0'}`,
          borderTopColor: 'transparent',
          display: 'inline-block',
          animation: 'navaAiSpin 0.8s linear infinite',
        }}
      />
      <span style={{ fontWeight: 600 }}>{label}</span>
      <span style={{ color: C.neutralDim ?? '#8a8a8a' }}>· {stage}</span>
      <span style={{ marginLeft: 'auto', fontFamily: 'monospace', color: C.neutralDim ?? '#8a8a8a' }}>
        {mm}:{ss}
      </span>
      <style>{`@keyframes navaAiSpin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}
